import {SumaDocumentVerificationStatus} from './participant-async-request.interface';

export enum SumaGlobalResult {
    Ok = 'Ok',
    Failed = 'Failed',
    DocumentExpired = 'DocumentExpired',
    FailedBiometrics = 'FailedBiometrics',
    ControlListHits = 'ControlListHits',
    DocumentUnacceptable = 'DocumentUnacceptable'
}

export type SumaDocumentVerificationResponse = {
    identifier: string;
    status?: SumaDocumentVerificationStatus;
    globalResult: SumaGlobalResult,
    globalResultDescription: string;
    message?: string;
}